import { render, staticRenderFns } from "./cvIndex.vue?vue&type=template&id=b6aa67b6&"
import script from "./cvIndex.vue?vue&type=script&lang=js&"
export * from "./cvIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports